import React from 'react';

export default function MesaSpinObjetivos() {
  return (
    <div className="h-screen w-full bg-gradient-to-br from-gray-900 via-red-900 to-orange-900 p-4">
      <div className="h-full w-full bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl overflow-hidden">
        <iframe
          src="/spin_objetivos/spin_objetivos_slideshow.html"
          title="Objetivos SPIN 2024"
          className="w-full h-full border-none"
          allow="fullscreen"
        />
      </div>
    </div>
  );
}